<template>
  <div class="cb-section">
    <template v-if="placeholder_list">
      <div class="cb-placeholder__section" v-for="idx in placeholderFirstTwoIndices" v-bind:key="idx">
        <cb-placeholder :custom-class="'sm'"></cb-placeholder>
        <cb-placeholder :custom-class="'sm rect-sm'"></cb-placeholder>
      </div>
      <div class="cb-placeholder__section" v-if="placeholder_list >= 3">
        <cb-placeholder :custom-class="'sm rect-md'" class="cb-placeholder__center"></cb-placeholder>
      </div>
    </template>
    <div v-else>
      <div class="cb-placeholder__section" v-for="i in 2" v-bind:key="i">
        <cb-placeholder :custom-class="'sm'"></cb-placeholder>
        <cb-placeholder :custom-class="'sm rect-sm'"></cb-placeholder>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Placeholder from "@/components/collections/elements/Placeholder"
export default {
  data() {
      return {
        placeholder_list: "",
      }
    },
    components: {
      "cb-placeholder": Placeholder,
    },
    computed: {
      /** Vue 3: avoid v-for + v-if on same node; placeholder_list is a numeric count. */
      placeholderFirstTwoIndices() {
        const n = this.placeholder_list;
        if (!n || typeof n !== "number") return [];
        const count = Math.min(n, 2);
        return [...Array(count).keys()];
      }
    },
    mounted() {
      this.placeholder_list = this.$store.state.customer ? this.$store.state.customer.subscriptions.length : 0;
    }
}
</script>